<template>
    <a-spin tip="Carregando..." :spinning="spinning">
        <div class="container">
            <a-card>
                <template #title>
                    <a-breadcrumb separator=">">
                        <a-breadcrumb-item>
                            <FileOutlined/>
                            <a href="/configurations/faqs"><span>Tutoriais</span></a>
                        </a-breadcrumb-item>
                        <a-breadcrumb-item>
                            {{ isEditMode ? 'Editar Tutorial' : 'Cadastrar Tutorial' }}
                        </a-breadcrumb-item>
                    </a-breadcrumb>
                </template>
                <a-row style="display: flex; justify-content: space-between; margin: 20px;">
                    <a-col :span="6" style="display: flex; align-items: center;">
                        <strong style="margin-right: 10px;">Ordem:</strong>
                        <a-input v-model:value="currentRegister.order" style="width: 200px"/>
                    </a-col>

                    <a-col :span="8" style="display: flex; align-items: center;">
                        <strong style="margin-right: 10px;">Nome:</strong>
                        <a-input v-model:value="currentRegister.name" style="width: 350px"/>
                    </a-col>

                    <a-col :span="8" style="display: flex; align-items: center;">
                        <strong style="margin-right: 10px;">Descrição:</strong>
                        <a-input v-model:value="currentRegister.description" style="width: 350px"/>
                    </a-col>
                </a-row>
                <a-row style="margin: 20px;">
                    <a-col :span="8">
                        <a-checkbox v-model:checked="currentRegister.isMain" style="font-weight:bold;">Tutorial principal</a-checkbox>
                    </a-col>
                </a-row>
                <a-row style="margin: 10px 20px">
                    <a-col :span="16">
                        <h4>HTML:</h4>
                        <p style="color: red; font-size: small; margin: 0">
                            Use o atributo data-id para criar um link para a sigla.
                            Ex: &lt;a data-id="1"&gt;Sigla 1&lt;/a&gt;
                        </p>
                        <p style="color: red; font-size: small">
                            Para usar imagem, utilize o caminho dela no campo src.
                            Ex: &lt;img height='100%' width='100%' src="/storage/images/img-1.png" /&gt;
                        </p>
                    </a-col>
                </a-row>
                <a-row style="margin: 10px 20px">
                    <a-col :span="16" style="height:410px">
                        <Codemirror
                            ref="cmRef"
                            v-model:value="currentRegister.html"
                            :options="cmOptions"
                            height="100%"
                            width="100%"
                            class="cm-component"
                            :border="true"
                        />
                    </a-col>
                    <a-col :span="8" class="center-flex" :style="{ backgroundColor:tableType?'#FFF':'#dcdcdc', overflowX:'auto' }">
                        <Transition name="slide-fade" mode="out-in">
                            <table-view v-if="tableType" :type="tableType"></table-view>
                            <div v-else-if="!tableType" style="display:flex;flex-direction:column">
                                <p style="opacity: 60%">Selecione uma tabela para visualizá-la aqui</p>
                                <a-dropdown placement="bottom" arrow>
                                    <a-button>Ver tabelas</a-button>
                                    <template #overlay>
                                        <a-menu>
                                            <a-menu-item @click="handleTable('faqs')">
                                                Tutoriais
                                            </a-menu-item>
                                            <a-menu-item @click="handleTable('imagens')">
                                                Imagens
                                            </a-menu-item>
                                        </a-menu>
                                    </template>
                                </a-dropdown>
                            </div>
                        </Transition>
                    </a-col>
                </a-row>
                <a-row style="margin: 0 20px">
                    <a-col :span="16" style="display:flex;gap:5px">
                        <a-tooltip :title="isEditMode ? 'Salvar Alterações' : 'Salvar'">
                            <a-button size="large" type="primary" @click="save" class="center-flex">
                                <template #icon>
                                    <SaveOutlined style="font-size: 18px;"/>
                                </template>
                            </a-button>
                        </a-tooltip>
                        <a-tooltip title="Preview HTML">
                            <a-button size="large" type="primary" class="center-flex" style="background-color:green;"
                                      @click="isModalVisible = true">
                                <template #icon>
                                    <EyeOutlined/>
                                </template>
                            </a-button>
                        </a-tooltip>
                    </a-col>
                    <a-col :span="8" class="center-flex" style="gap:5px">
                        <Transition name="slide-fade">
                            <template v-if="tableType">
                                <div class="center-flex" style="gap: 5px">
                                    <a-dropdown placement="top" arrow>
                                        <a-button size="large" class="center-flex" title="Alterar tabela">
                                            <template #icon>
                                                <TableOutlined/>
                                            </template>
                                        </a-button>
                                        <template #overlay>
                                            <a-menu>
                                                <a-menu-item @click="handleTable('faqs')">
                                                    Tutoriais
                                                </a-menu-item>
                                                <a-menu-item @click="handleTable('imagens')">
                                                    Imagens
                                                </a-menu-item>
                                            </a-menu>
                                        </template>
                                    </a-dropdown>
                                    <a-tooltip title="Remover tabela">
                                        <a-button size="large" danger class="center-flex" @click="tableType = ''">
                                            <template #icon>
                                                <DeleteOutlined/>
                                            </template>
                                        </a-button>
                                    </a-tooltip>
                                </div>
                            </template>
                        </Transition>
                    </a-col>
                </a-row>
            </a-card>
        </div>
    </a-spin>
    <a-modal v-model:open="isModalVisible" title="Preview HTML" footer=" " @ok="handleOk">
        <div v-html="currentRegister.html">
        </div>
    </a-modal>


</template>
<script setup>
import {ref, reactive, onMounted} from "vue";
import {DeleteOutlined, EyeOutlined, FileOutlined, SaveOutlined, TableOutlined} from '@ant-design/icons-vue';
import {notification} from 'ant-design-vue';
import Codemirror from "codemirror-editor-vue3";
import "codemirror/mode/htmlmixed/htmlmixed";
import "codemirror/theme/neat.css";
import axios from "axios";
import { openNotification } from "../../../../utils/utilities";

const props = defineProps(["id"]);
const isEditMode = ref(!!props.id);
const spinning = ref(false);
const tableType = ref('');

const faqs = ref([])
const routes = {
    zones: '/api/configurations/faqs'
}

const isModalVisible = ref(false);
const route = '/api/configurations/faqs';

const handleOk = () => {
    isModalVisible.value = false;
};

const handleTable = (type) => {
    (tableType.value === type) ? tableType.value = '' : tableType.value = type;
}

const columns = ref([
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            sorter: {
                compare: (a, b) => a.id - b.id,
            },
            width: 50,
        },
        {
            title: 'Nome',
            dataIndex: 'name',
            key: 'name',
            width: 150,
            sorter: {
                compare: (a, b) => a.name - b.name,
            },
        }
    ]
);

const cmRef = ref();

const cmOptions = reactive({
    mode: "text/html",
    theme: "default",
    readOnly: false,
    lineNumbers: true,
    lineWiseCopyCut: true,
    gutters: ["CodeMirror-lint-markers"],
    lint: true,
});

const currentRegister = ref({
    id: null,
    order: null,
    name: null,
    description: '',
    html: '',
    isMain: false,
})

const save = async () => {
    let {id, ...data} = currentRegister.value
    if (!id) {
        try {
            spinning.value = true
            const response = await window.axios.post(route, data)
            spinning.value = false
            openNotification('success', response.data.message)
            await (new Promise(resolve => setTimeout(resolve, 500)));
            window.location.href = `/configurations/faqs/create`
        } catch (error) {
            spinning.value = false
            openNotification('error', error.message)
        }
    } else {
        try {
            spinning.value = true
            await window.axios.put(route + `/${id}`, data)
            spinning.value = false
            window.location.href = `/configurations/faqs/`
        } catch (error) {
            spinning.value = false
            openNotification('error', error.message)
        }
    }
}

onMounted(async () => {
    if (props.id) {
        try {
            spinning.value = true
            let register = (await window.axios.get(`${route}/${props.id}`)).data.data
            spinning.value = false
            currentRegister.value.id = register.id
            currentRegister.value.order = register.order
            currentRegister.value.name = register.name
            currentRegister.value.description = register.description
            currentRegister.value.html = register.html
            currentRegister.value.isMain = register.isMain
            isEditMode.value = true
        } catch (error) {
            spinning.value = false
            openNotification('error', error.message)
        }
    }

    faqs.value = (await window.axios.get(route)).data.data.map(faq => {
        return {
            id: faq.id,
            order: faq.order,
            name: faq.name,
            description: faq.description,
            html: faq.html,
            isMain: faq.isMain
        }
    })
})
</script>
<style scoped>
.center-flex {
    display: flex;
    justify-content: center;
    align-items: center;
}

.cm-component {
    font-family: monospace;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.3s ease;
}

.slide-fade-enter-from {
    opacity: 0;
    transform: translateY(-20px);
}

.slide-fade-leave-to {
    opacity: 0;
    transform: translateY(-20px);
}
</style>
